import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformToDecimal',
})
export class TransformToDecimalPipe implements PipeTransform {

  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '0.00';
    }

    const parsed = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(parsed) || parsed === 0) {
      return '0.00';
    }

    return parsed.toFixed(2);
  }

}
